import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  INITIAL_LANGUAGE,
  LANG_QUERY_PARAM,
  SUPPORTED_LOCALES,
} from 'root-constants'
import { routeHistory } from 'route-history'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'

export const useSetLanguage = (): void => {
  const { pathname, search } = useLocation()

  useEffect(() => {
    const URLParams = new URLSearchParams(search)
    const langQueryParam = URLParams.get(LANG_QUERY_PARAM) || ''

    if (!SUPPORTED_LOCALES.includes(langQueryParam)) {
      const browserLang = window.navigator
        ? window.navigator.language.substring(0, 2)
        : ''
      const lang = SUPPORTED_LOCALES.includes(browserLang)
        ? browserLang
        : INITIAL_LANGUAGE

      useZustandSessionStore.setState({ language: lang })
      URLParams.set(LANG_QUERY_PARAM, lang)
      routeHistory.replace({
        pathname,
        search: URLParams.toString(),
      })
      return
    }

    useZustandSessionStore.setState({ language: langQueryParam })
  }, [pathname, search])
}
